import Season from "../schemas/Season";
import { team, manager } from "./stringConstants";

export const allSeasonsData: Season[] = [
    {
        year: "2009/10",
        totalTeams: 13,
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Lebron James",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Chris Paul",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.itay,
                    draftedPlayer: "Dwyane Wade",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.ran,
                    draftedPlayer: "Dirk Nowitzki",
                    becameKeeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.mati,
                    draftedPlayer: "Kevin Durant",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Danny Granger",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.spurs,
                    draftedPlayer: "Deron Williams",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.dom,
                    draftedPlayer: "Chris Bosh",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.sagi,
                    draftedPlayer: "Al Jefferson",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.asa,
                    draftedPlayer: "Kevin Garnett",
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Carlos Boozer",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.darko,
                    draftedPlayer: "Jose Calderon",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.jDog,
                    draftedPlayer: "David Lee",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Baron Davis",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.darko,
                    draftedPlayer: "Caron Butler",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Rajon Rondo",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.asa,
                    draftedPlayer: "Antawn Jamison",
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.sagi,
                    draftedPlayer: "Paul Pierce",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dom,
                    draftedPlayer: "Troy Murphy",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.spurs,
                    draftedPlayer: "Gilbert Arenas",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Jason Kidd",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.mati,
                    draftedPlayer: "Blake Griffin",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 23,
                    draftingManager: manager.ran,
                    draftedPlayer: "David West",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 24,
                    draftingManager: manager.itay,
                    draftedPlayer: "Kevin Martin",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 25,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Kevin Love",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 26,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Mehmet Okur",
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 1 },
            { teamName: team.domHawks, rank: 2 },
            { teamName: team.bMovieBlazers, rank: 3 },
            { teamName: team.philoozers, rank: 4 },
            { teamName: team.orlDunk, rank: 5 },
            { teamName: team.chi88, rank: 6 },
            { teamName: team.denver, rank: 7 },
            { teamName: team.detJews, rank: 8 },
            { teamName: team.bknNets, rank: 9 },
            { teamName: team.saMcdyess, rank: 10 },
            { teamName: team.gswRandolph, rank: 11 },
            { teamName: team.crashlots, rank: 12 },
            { teamName: team.laPoets, rank: 13 }
        ],
        movesLimit: false,
        totalMoves: 1194,
        injurySlot: false,
        franchisePlayersRequired: 6
    },
    {
        year: "2010/11",
        totalTeams: 13,
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Rajon Rondo",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.sagi,
                    draftedPlayer: "John Wall",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.mati,
                    draftedPlayer: "Troy Murphy",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Rudy Gay",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.asa,
                    draftedPlayer: "Zach Randolph",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.ran,
                    draftedPlayer: "David West",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Roy Hibbert",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.itay,
                    draftedPlayer: "Andrea Bargnani",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Marcus Camby",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.dom,
                    draftedPlayer: "Stephen Jackson",
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Luis Scola",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.michael,
                    draftedPlayer: "Marc Gasol",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.inbal,
                    draftedPlayer: "Andray Blatche",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.inbal,
                    draftedPlayer: "Paul Pierce",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.michael,
                    draftedPlayer: "Manu Ginobili",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Carl Landry",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.dom,
                    draftedPlayer: "Mo Williams",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Chris Kaman",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.itay,
                    draftedPlayer: "Kevin Martin",
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Aaron Brooks",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.ran,
                    draftedPlayer: "Carlos Boozer",
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.asa,
                    draftedPlayer: "Ray Allen",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 23,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Antawn Jamison",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 24,
                    draftingManager: manager.mati,
                    draftedPlayer: "John Salmons",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 25,
                    draftingManager: manager.sagi,
                    draftedPlayer: "Demarcus Cousins",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 26,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Lamar Odom",
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 2 },
            { teamName: team.domHawks, rank: 8 },
            { teamName: team.bMovieBlazers, rank: 3 },
            { teamName: team.philoozers, rank: 4 },
            { teamName: team.orlDunk, rank: 9 },
            { teamName: team.chi88, rank: 7 },
            { teamName: team.denver, rank: 6 },
            { teamName: team.detJews, rank: 13 },
            { teamName: team.bknNets, rank: 12 },
            { teamName: team.mavs, rank: 10 },
            { teamName: team.gswRandolph, rank: 5 },
            { teamName: team.crashlots, rank: 1 },
            { teamName: team.uthFlames, rank: 11 }
        ],
        movesLimit: false,
        totalMoves: 1555,
        injurySlot: false,
        franchisePlayersRequired: 4
    },
    {
        year: "2011/12",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Pau Gasol",
                    becameKeeper: true,
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.mati,
                    draftedPlayer: "Carmelo Anthony",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Kobe Bryant",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.dom,
                    draftedPlayer: "Rajon Rondo",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.ran,
                    draftedPlayer: "Joakim Noah",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.sagi,
                    draftedPlayer: "Zach Randolph",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.itay,
                    draftedPlayer: "Nene",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Deandre Jordan",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Dorell Wright",
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Ray Allen",
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.michael,
                    draftedPlayer: "Chris Bosh",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.michael,
                    draftedPlayer: "Jason Richardson",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Andrea Bargnani",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Manu Ginobili",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Marcin Gortat",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.itay,
                    draftedPlayer: "Andrew Bynum",
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.sagi,
                    draftedPlayer: "Tyson Chandler",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.ran,
                    draftedPlayer: "David West",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dom,
                    draftedPlayer: "Samuel Dalembert",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Ty Lawson",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.mati,
                    draftedPlayer: "Tim Duncan",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Paul Pierce",
                    amongBestPicks: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 3 },
            { teamName: team.domHawks, rank: 9 },
            { teamName: team.bMovieBlazers, rank: 5 },
            { teamName: team.philoozers, rank: 10 },
            { teamName: team.orlDunk, rank: 6 },
            { teamName: team.chi88, rank: 11 },
            { teamName: team.detJews, rank: 7 },
            { teamName: team.bknNets, rank: 1 },
            { teamName: team.gswRandolph, rank: 4 },
            { teamName: team.crashlots, rank: 2 },
            { teamName: team.uthFlames, rank: 8 }
        ],
        movesLimit: false,
        totalMoves: 1762,
        injurySlot: false,
        gamesPlayed: 66
    },
    {
        year: "2012/13",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.itay,
                    draftedPlayer: "Anthony Davis",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.dom,
                    draftedPlayer: "Danilo Gallinari"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.michael,
                    draftedPlayer: "Pau Gasol",
                    becameKeeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Marc Gasol",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Danny Granger"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.nissim,
                    draftedPlayer: "David Lee"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Ty Lawson",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.oded,
                    draftedPlayer: "Al Horford",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Damian Lillard",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Paul Pierce"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.mati,
                    draftedPlayer: "Kyle Lowry"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.mati,
                    draftedPlayer: "Joe Johnson",
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Andrei Kirilenko"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Ryan Anderson"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.oded,
                    draftedPlayer: "Stephen Curry",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Andrea Bargnani"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Gerald Wallace"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.jDog,
                    draftedPlayer: "Amare Stoudemire"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Arron Afflalo",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.michael,
                    draftedPlayer: "Jrue Holiday"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.dom,
                    draftedPlayer: "Marcus Thornton"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.itay,
                    draftedPlayer: "Joakim Noah",
                    amongBestPicks: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 2 },
            { teamName: team.domHawks, rank: 9 },
            { teamName: team.bMovieBlazers, rank: 7 },
            { teamName: team.philoozers, rank: 3 },
            { teamName: team.orlDunk, rank: 8 },
            { teamName: team.chi88, rank: 11 },
            { teamName: team.detJews, rank: 10 },
            { teamName: team.bknNets, rank: 6 },
            { teamName: team.gswRandolph, rank: 1 },
            { teamName: team.crashlots, rank: 5 },
            { teamName: team.uthFlames, rank: 4 }
        ],
        movesLimit: false,
        totalMoves: 1863,
        injurySlot: false
    },
    {
        year: "2013/14",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.oded,
                    draftedPlayer: "Joakim Noah",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Jrue Holiday"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.dom,
                    draftedPlayer: "Eric Bledsoe",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.alon,
                    draftedPlayer: "Victor Oladipo",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Nicolas Batum"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.mati,
                    draftedPlayer: "Mike Conley"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Roy Hibbert"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.michael,
                    draftedPlayer: "David Lee",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.itay,
                    draftedPlayer: "Monta Ellis"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Paul Millsap",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Ryan Anderson",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Jeff Teague"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "George Hill"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.itay,
                    draftedPlayer: "Thaddeus Young",
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.michael,
                    draftedPlayer: "Gordon Hayward",
                    becameKeeper: false
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.ariel,
                    draftedPlayer: "JaVale McGee"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.mati,
                    draftedPlayer: "Jeff Green"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Jose Calderon"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.alon,
                    draftedPlayer: "Rudy Gay",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.dom,
                    draftedPlayer: "Goran Dragic",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.kobe,
                    draftedPlayer: "DeMar DeRozan",
                    becameKeeper: false
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.oded,
                    draftedPlayer: "Andre Iguodala"
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 1 },
            { teamName: team.domHawks, rank: 8 },
            { teamName: team.bMovieBlazers, rank: 3 },
            { teamName: team.philoozers, rank: 5 },
            { teamName: team.orlDunk, rank: 10 },
            { teamName: team.chi88, rank: 9 },
            { teamName: team.detJews, rank: 6 },
            { teamName: team.bknNets, rank: 7 },
            { teamName: team.gswRandolph, rank: 2 },
            { teamName: team.crashlots, rank: 4 },
            { teamName: team.uthFlames, rank: 11 }
        ],
        movesLimit: false,
        totalMoves: 2049,
        vetDraftTopPick: 9,
        injurySlot: false
    },
    {
        year: "2014/15",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.idan,
                    draftedPlayer: "Jabari Parker",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.alon,
                    draftedPlayer: "Andrew Wiggins",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.oded,
                    draftedPlayer: "Nicolas Batum",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.dom,
                    draftedPlayer: "Gordon Hayward",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.mati,
                    draftedPlayer: "DeAndre Jordan",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Rudy Gay",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.itay,
                    draftedPlayer: "Chandler Parsons"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Derrick Rose",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Goran Dragic"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Monta Ellis",
                    amongWorstPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "DeMar DeRozan"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Elfrid Payton",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Ty Lawson"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Larry Sanders",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Wesley Matthews"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.itay,
                    draftedPlayer: "Ricky Rubio"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Jrue Holiday"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.mati,
                    draftedPlayer: "Deron Williams"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dom,
                    draftedPlayer: "Roy Hibbert"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.oded,
                    draftedPlayer: "Jeff Teague"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.alon,
                    draftedPlayer: "Ryan Anderson"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.idan,
                    draftedPlayer: "Kenneth Faried"
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 6 },
            { teamName: team.domHawks, rank: 2 },
            { teamName: team.bMovieBlazers, rank: 5 },
            { teamName: team.philoozers, rank: 9 },
            { teamName: team.orlDunk, rank: 8 },
            { teamName: team.chi88, rank: 9 },
            { teamName: team.detJews, rank: 4 },
            { teamName: team.bknNets, rank: 11 },
            { teamName: team.gswRandolph, rank: 1 },
            { teamName: team.crashlots, rank: 3 },
            { teamName: team.uthFlames, rank: 7 }
        ],
        movesLimit: true,
        totalMoves: 1426,
        vetDraftTopPick: 9,
        injurySlot: false
    },
    {
        year: "2015/16",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.mati,
                    draftedPlayer: "Derrick Favors",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.oded,
                    draftedPlayer: "Karl-Anthony Towns",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.itay,
                    draftedPlayer: "Al Horford",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.alon,
                    draftedPlayer: "Stanley Johnson",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.idan,
                    draftedPlayer: "Jeff Teague"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Jahlil Okafor",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Hassan Whiteside",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Brandon Knight"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Danny Green",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.dom,
                    draftedPlayer: "Goran Dragic"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Greg Monroe",
                    amongBestPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.chauncey,
                    draftedPlayer: "Isaiah Thomas"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.dom,
                    draftedPlayer: "Danilo Gallinari"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Nicolas Batum",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.idan,
                    draftedPlayer: "Tobias Harris"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Myles Turner",
                    becameKeeper: false,
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "DeMar DeRozan"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.idan,
                    draftedPlayer: "Ricky Rubio"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.alon,
                    draftedPlayer: "Enes Kanter"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.itay,
                    draftedPlayer: "Emmanuel Mudiay",
                    becameKeeper: false,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.oded,
                    draftedPlayer: "Chandler Parsons"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.mati,
                    draftedPlayer: "DeMarre Carroll"
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 6 },
            { teamName: team.domHawks, rank: 3 },
            { teamName: team.bMovieBlazers, rank: 5 },
            { teamName: team.philoozers, rank: 8 },
            { teamName: team.orlDunk, rank: 10 },
            { teamName: team.chi88, rank: 11 },
            { teamName: team.detJews, rank: 9 },
            { teamName: team.bknNets, rank: 7 },
            { teamName: team.gswRandolph, rank: 1 },
            { teamName: team.crashlots, rank: 1 },
            { teamName: team.uthFlames, rank: 4 }
        ],
        movesLimit: true,
        totalMoves: 1582,
        vetDraftTopPick: 9,
        injurySlot: false
    },
    {
        year: "2016/17",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Serge Ibaka",
                    becameKeeper: true,
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.itay,
                    draftedPlayer: "Kevin Love",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.shiran,
                    draftedPlayer: "DeMar DeRozan",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Ben Simmons",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.mati,
                    draftedPlayer: "Goran Dragic"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Nikola Vucevic",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Marcin Gortat"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.idan,
                    draftedPlayer: "Mike Conley",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jonas Valanciunas"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Gorgui Dieng"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Joel Embiid",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Enes Kanter"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Marc Gasol",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.dom,
                    draftedPlayer: "Dario Saric",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.idan,
                    draftedPlayer: "Danilo Gallinari",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Mason Plumlee"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Bradley Beal",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.mati,
                    draftedPlayer: "Steven Adams"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Jeff Teague",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Jae Crowder"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.itay,
                    draftedPlayer: "Ricky Rubio"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Rondae Hollis-Jefferson",
                    wasSleeper: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 5 },
            { teamName: team.domHawks, rank: 10 },
            { teamName: team.bMovieBlazers, rank: 4 },
            { teamName: team.philoozers, rank: 11 },
            { teamName: team.orlDunk, rank: 8 },
            { teamName: team.chi88, rank: 3 },
            { teamName: team.detJews, rank: 6 },
            { teamName: team.bknNets, rank: 2 },
            { teamName: team.gswRandolph, rank: 8 },
            { teamName: team.crashlots, rank: 6 },
            { teamName: team.uthFlames, rank: 1 }
        ],
        movesLimit: true,
        totalMoves: 1820,
        vetDraftTopPick: 9,
        injurySlot: false
    },
    {
        year: "2017/18",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.itay,
                    draftedPlayer: "Markelle Fultz",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.dom,
                    draftedPlayer: "Lonzo Ball",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Bradley Beal",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Dennis Smith Jr",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.ariel,
                    draftedPlayer: "DeMar DeRozan"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Goran Dragic"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Marc Gasol"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Jusuf Nurkic"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Clint Capela"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Danilo Gallinari",
                    amongWorstPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.idan,
                    draftedPlayer: "Ricky Rubio"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Jonas Valanciunas"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.mati,
                    draftedPlayer: "Victor Oladipo",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.idan,
                    draftedPlayer: "Khris Middleton",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Otto Porter Jr",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Dennis Schroder"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Jeff Teague"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Malik Monk",
                    becameKeeper: false,
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Nerlens Noel"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Gary Harris",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jayson Tatum",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.itay,
                    draftedPlayer: "Tim Hardaway Jr"
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 3 },
            { teamName: team.domHawks, rank: 11 },
            { teamName: team.bMovieBlazers, rank: 3 },
            { teamName: team.philoozers, rank: 7 },
            { teamName: team.orlDunk, rank: 1 },
            { teamName: team.chi88, rank: 6 },
            { teamName: team.detJews, rank: 3 },
            { teamName: team.bknNets, rank: 9 },
            { teamName: team.gswRandolph, rank: 10 },
            { teamName: team.crashlots, rank: 7 },
            { teamName: team.uthFlames, rank: 1 }
        ],
        movesLimit: true,
        totalMoves: 1764,
        vetDraftTopPick: 9,
        injurySlot: true
    },
    {
        year: "2018/19",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.dom,
                    draftedPlayer: "Deandre Ayton",
                    becameKeeper: true,
                    wasSleeper: true,
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Luka Doncic",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.mati,
                    draftedPlayer: "Clint Capela",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Kyrie Irving",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.itay,
                    draftedPlayer: "Trae Young",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Otto Porter Jr"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.ilya,
                    draftedPlayer: "DeMar DeRozan"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.nissim,
                    draftedPlayer: "CJ McCollum"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Blake Griffin",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.idan,
                    draftedPlayer: "Enes Kanter"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Steven Adams"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.zeev,
                    draftedPlayer: "Nikola Vucevic",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.idan,
                    draftedPlayer: "Gordon Hayward"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Gary Harris"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Jusuf Nurkic"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Eric Bledsoe"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Jonas Valanciunas"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.itay,
                    draftedPlayer: "Julius Randle"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Nicolas Batum"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.mati,
                    draftedPlayer: "Lou Williams"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Robert Covington",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.dom,
                    draftedPlayer: "Josh Richardson"
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 7 },
            { teamName: team.domHawks, rank: 8 },
            { teamName: team.bMovieBlazers, rank: 4 },
            { teamName: team.philoozers, rank: 5 },
            { teamName: team.orlDunk, rank: 2 },
            { teamName: team.chi88, rank: 3 },
            { teamName: team.detJews, rank: 10 },
            { teamName: team.bknNets, rank: 11 },
            { teamName: team.gswRandolph, rank: 6 },
            { teamName: team.crashlots, rank: 9 },
            { teamName: team.uthFlames, rank: 1 }
        ],
        movesLimit: true,
        totalMoves: 1839,
        vetDraftTopPick: 9,
        injurySlot: true
    },
    {
        year: "2019/20",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.mati,
                    draftedPlayer: "Zion Williamson",
                    becameKeeper: true,
                    wasSleeper: true,
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Ja Morant",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.ariel,
                    draftedPlayer: "RJ Barrett",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jimmy Butler",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Kyrie Irving",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Bradley Beal",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.itay,
                    draftedPlayer: "CJ McCollum"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Khris Middleton",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Robert Covington",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.dror,
                    draftedPlayer: "Jamal Murray"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.idan,
                    draftedPlayer: "Otto Porter Jr"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.idan,
                    draftedPlayer: "Steven Adams"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.dror,
                    draftedPlayer: "Derrick Favors"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Tobias Harris"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Montrezl Harrell"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.itay,
                    draftedPlayer: "Josh Richardson"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Dejounte Murray",
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Joe Ingles"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jonas Valanciunas",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Terry Rozier",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Eric Bledsoe",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.mati,
                    draftedPlayer: "Fred VanVleet",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 3 },
            { teamName: team.domHawks, rank: 5 },
            { teamName: team.bMovieBlazers, rank: 1 },
            { teamName: team.philoozers, rank: 6 },
            { teamName: team.orlDunk, rank: 8 },
            { teamName: team.chi88, rank: 2 },
            { teamName: team.detJews, rank: 7 },
            { teamName: team.bknNets, rank: 4 },
            { teamName: team.gswRandolph, rank: 11 },
            { teamName: team.crashlots, rank: 9 },
            { teamName: team.uthFlames, rank: 9 }
        ],
        movesLimit: true,
        totalMoves: 1160,
        vetDraftTopPick: 5,
        injurySlot: true,
        gamesPlayed: 65
    },
    {
        year: "2020/21",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Jusuf Nurkic",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Jamal Murray",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.idan,
                    draftedPlayer: "Brandon Ingram",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.dror,
                    draftedPlayer: "Hassan Whiteside",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Christian Wood",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.itay,
                    draftedPlayer: "Jaylen Brown",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.dom,
                    draftedPlayer: "CJ McCollum"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.mati,
                    draftedPlayer: "Robert Covington",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Kelly Oubre",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Myles Turner"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Davis Bertans",
                    amongWorstPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Montrezl Harrell",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Dejounte Murray"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.ilya,
                    draftedPlayer: "Eric Bledsoe",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.mati,
                    draftedPlayer: "Buddy Hield"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.dom,
                    draftedPlayer: "DeMarcus Cousins",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.itay,
                    draftedPlayer: "TJ Warren"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Victor Oladipo",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dror,
                    draftedPlayer: "Kevin Love",
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.idan,
                    draftedPlayer: "OG Anunoby",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Tobias Harris",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.ilya,
                    draftedPlayer: "James Wiseman",
                    becameKeeper: true,
                    wasSleeper: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 2 },
            { teamName: team.domHawks, rank: 3 },
            { teamName: team.bMovieBlazers, rank: 7 },
            { teamName: team.philoozers, rank: 6 },
            { teamName: team.orlDunk, rank: 8 },
            { teamName: team.chi88, rank: 9 },
            { teamName: team.detJews, rank: 11 },
            { teamName: team.bknNets, rank: 5 },
            { teamName: team.gswRandolph, rank: 10 },
            { teamName: team.crashlots, rank: 4 },
            { teamName: team.uthFlames, rank: 1 }
        ],
        movesLimit: true,
        totalMoves: 1386,
        vetDraftTopPick: 5,
        injurySlot: true,
        gamesPlayed: 72
    },
    {
        year: "2021/22",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Cade Cunningham",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.idan,
                    draftedPlayer: "Bam Adebayo",
                    becameKeeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Khris Middleton"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.dror,
                    draftedPlayer: "Jalen Suggs",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Evan Mobley",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.itay,
                    draftedPlayer: "De'Aaron Fox"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.mati,
                    draftedPlayer: "OG Anunoby"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Myles Turner"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.dom,
                    draftedPlayer: "Richaun Holmes",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Lonzo Ball"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.rony,
                    draftedPlayer: "Jonas Valanciunas",
                    amongBestPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.idan,
                    draftedPlayer: "CJ McCollum"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Jusuf Nurkic"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jalen Green",
                    wasSleeper: true,
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.ariel,
                    draftedPlayer: "D'Angelo Russell",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.mati,
                    draftedPlayer: "Jarrett Allen",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.itay,
                    draftedPlayer: "Mitchell Robinson"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Robert Williams",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dror,
                    draftedPlayer: "Derrick White"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Dejounte Murray",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.rony,
                    draftedPlayer: "Alperen Sengun",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Buddy Hield"
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 8 },
            { teamName: team.domHawks, rank: 6 },
            { teamName: team.bMovieBlazers, rank: 1 },
            { teamName: team.philoozers, rank: 11 },
            { teamName: team.orlDunk, rank: 10 },
            { teamName: team.chi88, rank: 2 },
            { teamName: team.detJews, rank: 7 },
            { teamName: team.bknNets, rank: 4 },
            { teamName: team.gswRandolph, rank: 9 },
            { teamName: team.crashlots, rank: 3 },
            { teamName: team.uthFlames, rank: 5 }
        ],
        movesLimit: true,
        totalMoves: 1742,
        vetDraftTopPick: 5,
        injurySlot: true,
        ILplus: true
    },
    {
        year: "2022/23",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.itay,
                    draftedPlayer: "Paolo Banchero",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.yoni,
                    draftedPlayer: "Zion Williamson",
                    becameKeeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.rony,
                    draftedPlayer: "Jabari Smith Jr",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "De'Aaron Fox"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Julius Randle"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.dom,
                    draftedPlayer: "Myles Turner",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.idan,
                    draftedPlayer: "Ben Simmons",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.mati,
                    draftedPlayer: "Michael Porter Jr"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Jakob Poeltl"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.shiran,
                    draftedPlayer: "CJ McCollum"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Clint Capela",
                    amongBestPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Brandon Ingram"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Jalen Brunson",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Mitchell Robinson"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.mati,
                    draftedPlayer: "Christian Wood"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.idan,
                    draftedPlayer: "Jamal Murray"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jaren Jackson Jr",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Lauri Markkanen",
                    amongBestPicks: true,
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Jusuf Nurkic"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.rony,
                    draftedPlayer: "Jordan Poole",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.yoni,
                    draftedPlayer: "Mikal Bridges",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.itay,
                    draftedPlayer: "Collin Sexton",
                    amongWorstPicks: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 2 },
            { teamName: team.domHawks, rank: 6 },
            { teamName: team.bMovieBlazers, rank: 1 },
            { teamName: team.philoozers, rank: 11 },
            { teamName: team.orlDunk, rank: 5 },
            { teamName: team.chi88, rank: 4 },
            { teamName: team.detJews, rank: 8 },
            { teamName: team.bknNets, rank: 2 },
            { teamName: team.gswRandolph, rank: 6 },
            { teamName: team.crashlots, rank: 8 },
            { teamName: team.uthFlames, rank: 10 }
        ],
        movesLimit: true,
        totalMoves: 1655,
        vetDraftTopPick: 5,
        injurySlot: true,
        ILplus: true
    },
    {
        year: "2023/24",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.itay,
                    draftedPlayer: "Victor Wembenyama",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.idan,
                    draftedPlayer: "Chet Holmgren",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Nic Claxton"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Jalen Brunson",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.dom,
                    draftedPlayer: "Kristaps Porzingis"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.rony,
                    draftedPlayer: "Scoot Henderson",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.yoni,
                    draftedPlayer: "De'Aaron Fox",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Dejounte Murray"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Jordan Poole",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.idan,
                    draftedPlayer: "Jakob Poeltl"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Anfernee Simons"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Jerami Grant"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.mati,
                    draftedPlayer: "Jamal Murray"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Brandon Ingram"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.shiran,
                    draftedPlayer: "OG Anunoby"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.yoni,
                    draftedPlayer: "Fred VanVleet",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.rony,
                    draftedPlayer: "Jarrett Allen"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.dom,
                    draftedPlayer: "Brandon Miller",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Clint Capela"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Ausar Thompson",
                    becameKeeper: true,
                    wasSleeper: true 
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.idan,
                    draftedPlayer: "Amen Thompson",
                    becameKeeper: true,
                    wasSleeper: true,
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.itay,
                    draftedPlayer: "Julius Randle",
                    becameKeeper: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 7 },
            { teamName: team.domHawks, rank: 8 },
            { teamName: team.bMovieBlazers, rank: 3 },
            { teamName: team.philoozers, rank: 4 },
            { teamName: team.orlDunk, rank: 2 },
            { teamName: team.chi88, rank: 1 },
            { teamName: team.detJews, rank: 9 },
            { teamName: team.bknNets, rank: 6 },
            { teamName: team.gswRandolph, rank: 9 },
            { teamName: team.crashlots, rank: 5 },
            { teamName: team.uthFlames, rank: 11 }
        ],
        movesLimit: true,
        totalMoves: 1564,
        vetDraftTopPick: 5,
        injurySlot: true,
        ILplus: true
    },
    {
        year: "2024/25",
        draftRounds: [
            {
                round: 1,
                draftPick: {
                    pickNumber: 1,
                    draftingManager: manager.idan,
                    draftedPlayer: "Donovan Mitchell",
                    becameKeeper: true,
                    wasSleeper: false,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 2,
                    draftingManager: manager.mati,
                    draftedPlayer: "Jalen Johnson",
                    becameKeeper: true,
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 3,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Zion Williamson",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 4,
                    draftingManager: manager.dom,
                    draftedPlayer: "Jarrett Allen",
                    amongBestPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 5,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Pascal Siakam"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 6,
                    draftingManager: manager.shahar,
                    draftedPlayer: "Jaylen Brown"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 7,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Nick Claxton",
                    amongWorstPicks: true
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 8,
                    draftingManager: manager.itay,
                    draftedPlayer: "Dejounte Murray"
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 9,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Donovan Clingan",
                    becameKeeper: true,
                    wasSleeper: true,
                }
            },
            {
                round: 1,
                draftPick: {
                    pickNumber: 10,
                    draftingManager: manager.yoni,
                    draftedPlayer: "Jamal Murray",
                    amongBestPicks: true
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 11,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Mikal Bridges"
                }
            },
            {
                round: 11,
                draftPick: {
                    pickNumber: 12,
                    draftingManager: manager.shiran,
                    draftedPlayer: "Deandre Ayton",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 13,
                    draftingManager: manager.yoni,
                    draftedPlayer: "Immanuel Quickley"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 14,
                    draftingManager: manager.nissim,
                    draftedPlayer: "Michael Porter Jr",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 15,
                    draftingManager: manager.itay,
                    draftedPlayer: "Alex Sarr",
                    becameKeeper: true,
                    wasSleeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 16,
                    draftingManager: manager.ariel,
                    draftedPlayer: "Brook Lopez"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 17,
                    draftingManager: manager.mati,
                    draftedPlayer: "Derrick White",
                    amongBestPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 18,
                    draftingManager: manager.yevgeny,
                    draftedPlayer: "Jusuf Nurkic",
                    amongWorstPicks: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 19,
                    draftingManager: manager.dom,
                    draftedPlayer: "Zaccharie Risacher",
                    wasSleeper: true,
                    becameKeeper: true
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 20,
                    draftingManager: manager.kobe,
                    draftedPlayer: "Deni Avdija"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 21,
                    draftingManager: manager.shahar,
                    draftedPlayer: "Brandon Ingram"
                }
            },
            {
                round: 2,
                draftPick: {
                    pickNumber: 22,
                    draftingManager: manager.idan,
                    draftedPlayer: "Jakob Poeltl",
                    amongBestPicks: true
                }
            }
        ],
        finalRanks: [
            { teamName: team.phxBastards, rank: 5 },
            { teamName: team.domHawks, rank: 6 },
            { teamName: team.bMovieBlazers, rank: 6 },
            { teamName: team.philoozers, rank: 8 },
            { teamName: team.orlDunk, rank: 4 },
            { teamName: team.chi88, rank: 3 },
            { teamName: team.detJews, rank: 8 },
            { teamName: team.bknNets, rank: 1 },
            { teamName: team.gswRandolph, rank: 11 },
            { teamName: team.crashlots, rank: 2 },
            { teamName: team.uthFlames, rank: 10 }
        ],
        movesLimit: true,
        totalMoves: 1568,
        vetDraftTopPick: 5,
        injurySlot: true,
        ILplus: true
    }
];